// Wizard step numbering ("Step 04 / 09"), derived rather than hardcoded.
//
// Each step component used to carry its own literal. That was fine while the
// sequence was fixed, but the transfer steps (listings / escrow / bba) are now
// removed for everyone via gate.skipTransfers, which left the agent reading
// "Step 05 / 09" and then "Step 09 / 09" with nothing in between.
//
// This list reproduces the previous numbering EXACTLY when nothing is hidden —
// agreements 03, adre 04, associations 05, listings 06, escrow 07, bba 08,
// finish 09 — so re-enabling the transfer steps restores the original labels
// with no further edits. `profile` and `intro` occupy 01 and 02: they are counted
// in the total but never rendered an eyebrow of their own.
export const NUMBERED_STEPS = [
  "profile", "intro", "agreements", "adre", "associations",
  "listings", "escrow", "bba", "finish",
];

const pad = (n) => String(n).padStart(2, "0");

/**
 * @param {string} key      step key, e.g. "adre"
 * @param {string[]} hidden step keys currently removed from the wizard
 * @returns {string} "Step 04 / 06", or "" if the step is not numbered/visible
 */
export function stepEyebrow(key, hidden = []) {
  const visible = NUMBERED_STEPS.filter((k) => !hidden.includes(k));
  const i = visible.indexOf(key);
  if (i === -1) return "";
  return `Step ${pad(i + 1)} / ${pad(visible.length)}`;
}
